import { ScrollRestoration as RouterScrollRestoration } from "react-router"

import { useScrollRestorationKey } from "../useDeferredScrollRestoration"

export default function ScrollRestoration() {
  const getKey = useScrollRestorationKey()
  return <RouterScrollRestoration getKey={getKey} />
}
